import { render } from "./NCCreate.vue?vue&type=template&id=7fd8ca6c&scoped=true"
import script from "./NCCreate.vue?vue&type=script&lang=js"
export * from "./NCCreate.vue?vue&type=script&lang=js"

import "./NCCreate.vue?vue&type=style&index=0&id=7fd8ca6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd8ca6c"]])

export default __exports__